import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Planning/getSugerenciasExtraccion`, method: 'POST', body: values, token: token})
}